// extracted by mini-css-extract-plugin
export default {"editorWrapper":"TiptapEditor_editorWrapper__63jy9","is-editor-empty":"TiptapEditor_is-editor-empty__qULV7"};